import { type ReactNode } from 'react';
import type { CreatorStatus } from '@/types';
import { cn } from '@/utils/cn';

const CFG: Record<CreatorStatus, { label: string; cls: string }> = {
  new: { label: 'Nuevo', cls: 'text-text-tertiary bg-white/[0.04]' },
  contacted: { label: 'Contactado', cls: 'text-info bg-info/10' },
  negotiating: { label: 'Negociando', cls: 'text-warning bg-warning/10' },
  closed_won: { label: 'Cerrado', cls: 'text-success bg-success/10' },
  closed_lost: { label: 'Perdido', cls: 'text-error bg-error/10' },
  promotion: { label: 'Promo', cls: 'text-brand-red bg-brand-red/10' },
};

const FALLBACK = CFG.new;

export function CreatorStatusBadge({
  status,
}: {
  status: CreatorStatus | undefined | '';
}): ReactNode {
  // Defensive fallback: leads created outside the normal flow (legacy data,
  // raw PB inserts) can have status="" or an unknown value. Crashing the
  // whole /creators list because of one stray row is worse than rendering
  // it as "Nuevo".
  const cfg = (status && CFG[status as CreatorStatus]) || FALLBACK;
  return (
    <span
      className={cn(
        'inline-flex whitespace-nowrap rounded-sm px-1.5 py-0.5 text-[11px] font-medium',
        cfg.cls
      )}
    >
      {cfg.label}
    </span>
  );
}
